/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { CommonImageInput, CommonInput, PageToolbar, CategorySelect2 } from "../common";
import SimpleEditor from "../common/SimpleEditor";
import helpers from "../../_helpers/common";
import { Category, Epuja } from "../../types/interfaces"
import { createFormErrors, FormError } from '../../utility/formUtils';
import useCommonActions from "../../hooks/useCommonActions";
import useAxios from "../../hooks/useAxios";

type ProductErrors = Record<string, string>;

const CreateUpdateProduct: React.FC = () => {
  const axiosInstance  = useAxios();
  const { product_id } = useParams();
  const navigate       = useNavigate();
  const { deleteItem } = useCommonActions();
  const [ categories, setCategory ] = useState<Category[] | null>(null);
  const [ formData, setFormData ] = useState<Epuja>({ title: '', category_id: [], time: '', short_description: '', description: '', 													puja_steps: '', booking_steps: '', benefits: '', tags: '', seo_title: '', 														seo_keyword: '', seo_description: '', price: '', upfront_amount: '',
                                                        discount_type: '', discount: '', discount_amount: '', sales_price: '', tax: '', display_image: '', banner_image: '', status: '' });
  const [ errors, setErrors ] = useState<Partial<ProductErrors>>({});
  //const [errors, setErrors] = useState<FormError<Epuja>>({});
  const [ displayimage, setDisplayImage ] = useState<File | null>(null);
  const [ bannerimage, setBannerImage ] = useState<File | null>(null);

 
  const [ formSubmitted, setFormSubmitted ] = useState(false);
  const [ isSubmitting, setIsSubmitting ] = useState(false);

  const descriptionRef = useRef<any>(null);
  const benefitsRef = useRef<any>(null);
  const howtouseRef = useRef<any>(null);
  
  useEffect(() => {
	getFormData();
  }, [])
  
  //reset galery and display image error on set
  useEffect(() => {
	if(bannerimage){
		setErrors((prev) => ({
			...prev,
			banner_image: undefined,
		}));
	}
	if(displayimage){
		setErrors((prev) => ({
			...prev,
			display_image: undefined,
		}));
	}
  }, [bannerimage, displayimage])
  
  const getFormData = async() => {
	try {
	  const response: any = await axiosInstance({
		url: `epuja/get-form-data/${product_id}`,
		method: "GET",
	  });
	  console.log('Form Data response', response);
	  if(!response.error){
		setCategory(response.data.categories);
		if(product_id !== '0'){
			let product = response.data.product;
			setFormData({ ...formData, category_id: product.category_id, time: product.time,
			  title: product.title, short_description: product.short_description, description: product.description, puja_steps: product.puja_steps, booking_steps: product.booking_steps, benefits: product.benefits, tags: product.tags, seo_title: product.seo_title, seo_keyword: product.seo_keyword, seo_description: product.seo_description, price: product.price, upfront_amount: product.upfront_amount,
              discount_type: product.discount_type, discount: product.discount, sales_price: product.sales_price, tax: product.tax, display_image: product.displaypath, banner_image: product.bannerpath, status: product.status
			})
		}
	  }
	} catch (error: any) {
	  console.log('catch error', error)
	} finally {
	  
	}
  }

  // Handle form input changes
  const handleFormInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement |HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    //console.log('input name', name);
    let clean_value: string | number = value;
    if (name === "discount_type") {
      clean_value = Number(clean_value);
    }
    setFormData((prev) => ({
      ...prev,
      [name]: clean_value,
    }));
	//reset the error
	setErrors((prev) => ({
		...prev,
		[name]: undefined,
	}));
  };
  
  const handleFormNumberChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement |HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    //console.log('input name', name);
    let clean_value: string | number = helpers.sanitizePrice(value);
    
    setFormData((prev) => ({
      ...prev,
      [name]: clean_value,
    }));
	
	//reset the error
	setErrors((prev) => ({
		...prev,
		[name]: undefined,
	}));
  };

  const validate = async (): Promise<boolean> => {
	  // Initialize empty error object using the utility
	  //const newErrors = createFormErrors(formData);
      const newErrors: Partial<ProductErrors> = {};
	  // Validate fields
	  if (!formData.category_id && formData.category_id.length === 0) {
		newErrors.category_id = 'Ctaegory is required';
	  }
	  
	  if (!formData.title) {
		newErrors.title = 'Title is required';
	  }
	  
	  if (!formData.time) {
		newErrors.time = 'Time is required';
	  }

      if (!formData.short_description) {
		newErrors.short_description = 'Short description is required';
	  }
	  
	  if (!formData.description) {
		newErrors.description = 'Description is required';
	  }

      if (!formData.benefits) {
		newErrors.benefits = 'Benefits is required';
	  }
	  
	  if (!formData.puja_steps) {
		newErrors.puja_steps = 'Puja steps is required';
	  }
	  
	  if (!formData.booking_steps) {
		newErrors.booking_steps = 'Booking steps is required';
	  }
	  
	  if (!formData.price) {
		newErrors.price = 'Price is required';
	  }

      if (!formData.upfront_amount) {
		newErrors.upfront_amount = 'Upfront Amount is required';
	  }
	  
	  if (formData.discount_type && formData.discount_type !== '') {
		if (!formData.discount) {
		  newErrors.discount = 'Discount is required';
		}
	  }
	  
	  if (formData.discount && formData.discount !== '') {
		if (!formData.discount_type) {
		  newErrors.discount_type = 'Discount type is required';
		}
	  }

	  if (!formData.status) {
		newErrors.status = 'Status is required';
	  }

	  if (!displayimage && formData.display_image === '') {
	    newErrors.display_image = "Display image is required";
	  }
	  
	  if (!bannerimage && formData.banner_image === '') {
	    newErrors.banner_image = "Banner image is required";
	  }
      //console.log('newErrors', newErrors);
	  setErrors(newErrors);

	  // Return true if there are no errors
	  return Object.keys(newErrors).length === 0;
  };

  /*Submit Form*/
  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();
	let isValid = await validate();
	
	if (isValid) {
	  setIsSubmitting(true);
	  var form_data = await prepareSubmitData();
	  let submit_url = product_id !== '0' ? `epuja/update-product/${product_id}` : `epuja/create-product`;
	  let submit_method = product_id !== '0' ? "PUT" : "POST";
	  try {
		const response: any = await axiosInstance({
			url: submit_url,
			method: submit_method,
			data: form_data,
			headers: {
			  'Content-Type': 'multipart/form-data',
			},
			timeout: 40000,
		});
		
		//on product creation success redirect back to list
		if(!response.error){
		  navigate('/epuja-list');
		}
	  } catch (error: any) {
		//console.log("validation_error catch", error?.response);

		  if (error?.response?.data?.type === "validation_error") {
			const errorsObj = error.response.data.message.errors as Record<string, string[]>;

			const newErrors: ProductErrors = {};

			(Object.keys(errorsObj) as Array<keyof Epuja>).forEach((field) => {
			  newErrors[field] = errorsObj[field][0];
			});

			setErrors(newErrors);
		  
		  } else {
			console.log("catch error", error);
		  }
	  } finally {
		setIsSubmitting(false);
	  }
	} 
  }
  
  /*Preapare Submit Form Data*/
  const prepareSubmitData = async () => {
	const form_Data = new FormData();
	let discount_amount = helpers.calculateDiscount({price: parseFloat(formData.price), discount: parseFloat(formData.discount), discountType: parseInt(formData.discount_type)});
	let sales_price = parseFloat(formData.price) - discount_amount;
	
	if(displayimage){
	  form_Data.append('display_image', displayimage);
    }
	if(bannerimage){
	  form_Data.append('banner_image', bannerimage);
    }
	/*form_Data.append(
	  'category_id',
	  typeof formData.category_id === 'string'
		? formData.category_id
		: formData.category_id?._id?.toString() || ''
	);*/
	form_Data.append("category_id", JSON.stringify(formData.category_id || []));
	form_Data.append('time', formData.time);
	form_Data.append('title', formData.title);
	form_Data.append('short_description', formData.short_description);
	form_Data.append('description', formData.description);
	form_Data.append('puja_steps', formData.puja_steps);
	form_Data.append('booking_steps', formData.booking_steps);
	form_Data.append('benefits', formData.benefits);
	form_Data.append('tags', formData.tags);
	form_Data.append('seo_title', formData.seo_title || '');
	form_Data.append('seo_keyword', formData.seo_keyword || '');
	form_Data.append('seo_description', formData.seo_description || '');
	form_Data.append('price', formData.price);
	form_Data.append('upfront_amount', formData.upfront_amount);
	form_Data.append('discount_type', (formData.discount_type ?? 0).toString());
	form_Data.append('discount', formData.discount);
	form_Data.append('discount_amount', (discount_amount ?? 0).toString());
	form_Data.append('sales_price', (sales_price ?? 0).toString());
	form_Data.append('tax', formData.tax);
	form_Data.append('status', (formData.status ?? 0).toString());
	return form_Data;
  }
  const handleCategoryChange = (e) => {
	  console.log('e', e);
	  //console.log('value', value);
  }
  console.log('formData', formData);
  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/*Page toolbar Area Start*/}
      <PageToolbar title={product_id === '0' ? "Create Epuja" : "Update Epuja"} />
      {/*Page toolbar Area End*/}
      {/*Page Conent Area Start*/}
      <div className="app-content flex-column-fluid">
        <div className="app-container">
          <form className="form d-flex flex-column flex-lg-row">
            <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
              <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Display Image</label>
                  <br />
                  <div className="text-center mb-3">
                    <CommonImageInput
                      fieldName="display_image"
                      defaultImage={formData.display_image !== '' ? formData.display_image : "/assets/media/svg/blank-image.svg"}
                      onImageChange={(file) => setDisplayImage(file)}
                    />
                  </div>
				  {errors.display_image && (
					  <span className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
						{errors.display_image}
					  </span>
				  )}
                  <div className="text-muted fs-7">
                    Set the display image. Only *.png, *.jpg and *.jpeg
                    image files are accepted
                  </div>
                </div>
              </div>
			  <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Banner Image</label>
                  <br />
                  <div className="text-center mb-3">
                    <CommonImageInput
                      fieldName="banner_image"
                      defaultImage={formData.banner_image !== '' ? formData.banner_image : "/assets/media/svg/blank-image.svg"}
                      onImageChange={(file) => setBannerImage(file)}
                    />
                  </div>
				  {errors.banner_image && (
					  <span className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
						{errors.banner_image}
					  </span>
				  )}
                  <div className="text-muted fs-7">
                    Set the banner image. Only *.png, *.jpg and *.jpeg
                    image files are accepted
                  </div>
                </div>
              </div>
			  {/*<div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Category</label>
                  <select
					className={`form-select mb-2 ${errors.category_id ? "is-invalid" : ""}`}
                    name="category_id"
                    value={typeof formData.category_id === 'string' ? formData.category_id : ''}
                    onChange={handleFormInputChange}
                  >
                    <option value="">Select an Category</option>
					{categories?.map((cat) => (
					  <option key={cat._id} value={cat._id}>{cat.title}</option>
				    ))}
                  </select>
				  {errors.category_id && (
					  <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
						{typeof errors.category_id === "string" ? errors.category_id : ''}
					  </div>
				  )}
                  <div className="text-muted text-info fs-7">
                    Set the product category.
                  </div>
                </div>
			  </div>*/}
			  <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Puja Duration</label>
					<CommonInput
					  type="text"
					  name="time"
					  placeholder="Puja Time"
					  value={formData.time}
					  onChange={handleFormInputChange}
					  error={errors.time}
					/>
                  <div className="text-muted text-info fs-7">
                    Set the time taken in puja.
                  </div>
                </div>
              </div>
			  {/*Price Section Start*/}
			 
				<div className="card card-flush py-1">
					<div className="card-header">
					  <div className="card-title">
						<h2>Pricing</h2>
					  </div>
					</div>
					<div className="card-body pt-0">
					  <div className="mb-4 fv-row fv-plugins-icon-container">
						<label className="required form-label">Price (Rs)</label>
						<CommonInput
						  type="text"
						  name="price"
						  placeholder="Product Price"
						  value={formData.price}
						  onChange={handleFormNumberChange}
						  error={errors.price}
						/>
					  </div>
					  <div className="mb-4 fv-row fv-plugins-icon-container">
						<label className="required form-label">Upfront Amount (Rs)</label>
						<CommonInput
						  type="text"
						  name="upfront_amount"
						  placeholder="Upfront Amount"
						  value={formData.upfront_amount}
						  onChange={handleFormNumberChange}
						  error={errors.upfront_amount}
						/>
					  </div>
					  {/*Discount Type Start*/}
					  <div className="fv-row mb-10">
						   <label className="fs-6 fw-semibold mb-2">Discount Type</label>
						   <div className="row">
							  <div className="col">
								 <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-3 ${Number(formData.discount_type) === 1 ? 'active' : ''}`}>
								   <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
									  <input
										className="form-check-input"
										type="radio"
										name="discount_type"
										value="1"
										onChange={handleFormInputChange}
										checked={Number(formData.discount_type) === 1}
									  />
								   </span>
								   <span className="ms-5">
									  <span className="fs-4 fw-bold text-gray-800 d-block">Percentage %</span>
								   </span>
								 </label>
							  </div>
							  {errors.discount_type && <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">{errors.discount_type}</div>}
						   </div>
						</div>
					  {/*Discount Type End*/}
					  <div className="mb-4 fv-row fv-plugins-icon-container">
						<label className="required form-label">Discount</label>
						<CommonInput
						  type="text"
						  name="discount"
						  placeholder="Discount"
						  value={formData.discount}
						  onChange={handleFormNumberChange}
						  error={errors.discount}
						/>
					  </div>
					</div>
				  </div>
			  {/*Price Section End*/}
			  <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Status</label>
                  <select
					className={`form-select mb-2 ${errors.status ? "is-invalid" : ""}`}
                    name="status"
                    value={formData.status}
                    onChange={handleFormInputChange}
                  >
                    <option value="">Select an Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
				  {errors.status && <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">{errors.status}</div>}
                  <div className="text-muted text-info fs-7">
                    Set the product status.
                  </div>
                </div>
              </div>
			  <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <label className="required form-label">Tags</label>
                  <CommonInput
					  type="text"
					  name="tags"
					  placeholder="Enter Product tags"
					  value={formData.tags}
					  onChange={handleFormInputChange}
					  error={errors.tags}
					/>
                  <div className="text-muted text-info fs-7">
                    Set the puja tags comma seprated.
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-8">
              <div className="card card-flush py-1">
                <div className="card-header">
                  <div className="card-title">
                    <h2>General Info</h2>
                  </div>
                </div>
                <div className="card-body pt-0">
				  <div className="mb-4 fv-row fv-plugins-icon-container">
                    <label className="required form-label">Puja Category</label>
				    <CategorySelect2
					  categories={categories || []}
					  multiple={true}
					  name="category_id"
					  value={
						Array.isArray(formData.category_id)
						  ? formData.category_id.map((c: any) => (typeof c === "string" ? c : c._id))
						  : []
					  }
					  onChange={({ name, value }) =>
						setFormData((prev) => ({ ...prev, [name]: value }))
					  }
					/>
				  </div>	
                  <div className="mb-4 fv-row fv-plugins-icon-container">
                    <label className="required form-label">Puja Name</label>
                    <CommonInput
                      type="text"
                      name="title"
                      placeholder="Puja Name"
                      value={formData.title}
                      onChange={handleFormInputChange}
					  error={errors.title}
                    />
                  </div>
				  <div className="mb-4 fv-row fv-plugins-icon-container">
                    <label className="required form-label">Puja Steps</label>
                    <CommonInput
                      type="text"
                      name="puja_steps"
                      placeholder="Puja Steps"
                      value={formData.puja_steps}
                      onChange={handleFormInputChange}
					  error={errors.puja_steps}
                    />
                  </div>
				  <div className="mb-4 fv-row fv-plugins-icon-container">
                    <label className="required form-label">Booking Steps</label>
                    <CommonInput
                      type="text"
                      name="booking_steps"
                      placeholder="Puja Name"
                      value={formData.booking_steps}
                      onChange={handleFormInputChange}
					  error={errors.booking_steps}
                    />
                  </div>
				   <div className="mb-4 fv-row fv-plugins-icon-container">
                    <label className="required form-label">Short Description</label>
                    <CommonInput
                      type="text"
                      name="short_description"
                      placeholder="Short Description"
                      value={formData.short_description}
                      onChange={handleFormInputChange}
					  error={errors.short_description}
                    />
                  </div>
                  <div className="mb-4">
					<SimpleEditor
					  label="Description"
					  required={true}
					  value={formData.description || ""}
					  onChange={(content) => {
						setFormData((prev) => ({ ...prev, description: content }));

						// reset error
						setErrors((prev) => ({ ...prev, description: undefined }));
					  }}
					  placeholder="Enter description..."
					  height={100}
					  error={errors?.description}
					/>
                    <div className="text-muted fs-7">
                      Set a description to the product.
                    </div>
                  </div>
				  <div className="mb-4">
					<SimpleEditor
					  label="Benefits"
					  required={true}
					  value={formData.benefits || ""}
					  onChange={(content) => {
						setFormData((prev) => ({ ...prev, benefits: content }));

						// reset error
						setErrors((prev) => ({ ...prev, benefits: undefined }));
					  }}
					  placeholder="Enter benefits..."
					  height={100}
					  error={errors?.benefits}
					/>
                    <div className="text-muted fs-7">
                      Set the benefits of the product.
                    </div>
                  </div>
                </div>
              </div>
			  <div className="fv-row mb-10">
				  <div className="row g-9">
					<div className="col">
					  <div className="card card-flush py-1">

						{/* Header */}
						<div className="card-header d-flex justify-content-between align-items-center">
						  <div className="card-title">
							<h2 className="mb-0">SEO Details</h2>
						  </div>

						  {/* Collapse Button */}
						  <button
							className="btn btn-sm btn-light-primary"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#seoDetailsCollapse"
							aria-expanded="true"
							aria-controls="seoDetailsCollapse"
						  >
							Toggle
						  </button>
						</div>

						{/* Body (Collapsable) */}
						<div id="seoDetailsCollapse" className="collapse show">
						  <div className="card-body pt-0">
							<div className="mb-10">
							  <label className="form-label">Meta Tag Title</label>
							  <CommonInput
								type="text"
								name="seo_title"
								placeholder="Meta tag name"
								value={formData.seo_title}
								onChange={handleFormInputChange}
							  />
							</div>

							<div className="mb-10">
							  <label className="form-label">Meta Tag Description</label>
							  <CommonInput
								type="text"
								name="seo_description"
								placeholder="Meta Tag Description"
								value={formData.seo_description}
								onChange={handleFormInputChange}
							  />
							</div>

							<div className="mb-15">
							  <label className="form-label">Meta Tag Keywords</label>
							  <CommonInput
								type="text"
								name="seo_keyword"
								placeholder="Meta Tag Keywords"
								value={formData.seo_keyword}
								onChange={handleFormInputChange}
							  />

							  <div className="text-muted fs-7">
								Set a list of keywords that the product is related to. Separate the keywords by adding a comma{" "}
								<code>,</code> between each keyword.
							  </div>
							</div>
						  </div>
						</div>

					  </div>
					</div>
				  </div>
				</div>

              <div className="d-flex justify-content-end">
                <Link to="/epuja-list" className="btn btn-light me-5">
                  Cancel
                </Link>
				{isSubmitting ? (
				  <button
					type="button"
					className="btn btn-primary"
					disabled={true}
				  >
					<span
					  className="indicator-progress"
					  style={{ display: "block" }}
					>
					  Please wait...
					  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
					</span>
				  </button>
				) : (
				  <button
					type="button"
					className="btn btn-primary"
					onClick={(e) => submitForm(e)}
				  >
					<span className="indicator-label">Submit</span>
				  </button>
				)}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/*Page Conent Area End*/}
    </div>
  );
};

export default CreateUpdateProduct;
